<template>
  <v-container grid-list-md>
    <v-layout row wrap justify-center mt-4 mb-2>
      <v-flex xs12 sm10 md8>
        <v-layout row wrap>
          <v-flex xs12 mb-4>
            <v-select
              dense
              hide-details
              :items="types"
              item-text="text"
              item-value="value"
              v-model="type"
              label="Select report"
            ></v-select>
          </v-flex>
          <v-flex xs12 md6>
            <date-picker label="Start Date" v-model="startDate"></date-picker>
          </v-flex>
          <v-flex xs12 md6>
            <date-picker label="End Date" v-model="endDate"></date-picker>
          </v-flex>
          <v-flex xs12 class="text-xs-right">
            <v-btn @click="generate" class="mx-0" color="success">Generate Report</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  middleware: "admin",
  computed: {
    startDate: {
      get() {
        return this.$store.state.base.startDate;
      },
      set(val) {
        this.$store.commit("base/setStartDate", val);
      }
    },

    endDate: {
      get() {
        return this.$store.state.base.endDate;
      },
      set(val) {
        this.$store.commit("base/setEndDate", val);
      }
    },

    type: {
      get() {
        return this.$store.state.base.type;
      },
      set(val) {
        this.$store.commit("base/setType", val);
      }
    }
  },
  data() {
    return {
      types: [
        { text: "Summary Report", value: "summary" },
        { text: "Appointments Report", value: "appointments" },
        { text: "Expneses Report", value: "expenses" },
        { text: "Payments Report", value: "payments" },
        { text: "Diagnoses Report", value: "diagnoses" }
      ]
    };
  },
  methods: {
    generate() {
      const report = {
        type: this.type,
        startDate: this.startDate,
        endDate: this.endDate
      };

      this.axios
        .get(
          `/api/reports?type=${this.type}&start_date=${
            this.startDate
          }&end_date=${this.endDate}`
        )
        .then(resp => {
          report.data = resp.data;
          this.$store.commit("base/setReports", report);

          if (this.$route.query.type)
            this.$router.replace(`/reports/${this.type}`);
          else this.$router.push(`/reports/${this.type}`);
        });
    }
  },
  mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
      this.generate();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>